import { useMemo } from 'react';
import { initializeReactMetadata } from '@Services/ResultsDataManage/initializeReactMetadata';

export default function useResultsMetadata(params) {
  return useMemo(() => initializeReactMetadata(params), [params]);
}
